'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "className", "animate", "easing", "duration", "delay", "staggerDurationBy", "staggerDelayBy", "appearAnimation", "enterAnimation", "leaveAnimation", "maintainContainerHeight", "onStart", "onFinish", "onStartAll", "onFinishAll", "typeName", "disableAllAnimations", "getPosition"];
import PropTypes from 'prop-types';
import { Children, cloneElement, Component } from 'react';
import FlipMove from 'react-flip-move';
import { callIfPossible } from 'foundations-components/transitional/utils/functions';

// For detailed react-flip-move@2.9.15 type definitions, see https://github.com/joshwcomeau/react-flip-move/blob/v2.9.15/typings/react-flip-move.d.ts
import { jsx as _jsx } from "react/jsx-runtime";
const FlipMoveAnimationPropType = PropTypes.oneOfType([PropTypes.oneOf(['elevator', 'fade', 'accordionVertical', 'accordionHorizontal', 'none']), PropTypes.bool, PropTypes.shape({
  from: PropTypes.object,
  to: PropTypes.object
})]);
export const FlipMovePropTypes = {
  easing: PropTypes.string,
  duration: PropTypes.number,
  delay: PropTypes.number,
  staggerDurationBy: PropTypes.number,
  staggerDelayBy: PropTypes.number,
  appearAnimation: FlipMoveAnimationPropType,
  enterAnimation: FlipMoveAnimationPropType,
  leaveAnimation: FlipMoveAnimationPropType,
  maintainContainerHeight: PropTypes.bool,
  onStart: PropTypes.func,
  onFinish: PropTypes.func,
  onStartAll: PropTypes.func,
  onFinishAll: PropTypes.func,
  typeName: PropTypes.string,
  disableAllAnimations: PropTypes.bool,
  getPosition: PropTypes.func
};
class UIDragList extends Component {
  renderChildren() {
    const _this$props = this.props,
      {
        children
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return Children.map(children, child => /*#__PURE__*/cloneElement(child, rest));
  }
  render() {
    const {
      children: __children,
      className,
      animate,
      easing,
      duration,
      delay,
      staggerDurationBy,
      staggerDelayBy,
      appearAnimation,
      enterAnimation,
      leaveAnimation,
      maintainContainerHeight,
      onStart,
      onFinish,
      onStartAll,
      onFinishAll,
      typeName,
      disableAllAnimations,
      getPosition
    } = this.props;
    if (animate) {
      return /*#__PURE__*/_jsx(FlipMove, {
        className: className,
        easing: easing,
        duration: duration,
        delay: delay,
        staggerDurationBy: staggerDurationBy,
        staggerDelayBy: staggerDelayBy,
        appearAnimation: appearAnimation,
        enterAnimation: enterAnimation,
        leaveAnimation: leaveAnimation,
        maintainContainerHeight: maintainContainerHeight,
        onStart: onStart,
        onFinish: onFinish,
        onStartAll: onStartAll,
        onFinishAll: onFinishAll,
        typeName: typeName,
        disableAllAnimations: disableAllAnimations,
        getPosition: getPosition,
        "data-test-id": "UIDragList:FlipMove",
        children: this.renderChildren()
      });
    }
    return /*#__PURE__*/_jsx("div", {
      className: className,
      children: this.renderChildren()
    });
  }
}
UIDragList.propTypes = Object.assign({
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.element), PropTypes.element]).isRequired,
  className: PropTypes.string,
  animate: PropTypes.bool
}, FlipMovePropTypes);
UIDragList.defaultProps = {
  animate: true,
  easing: 'cubic-bezier(.42, .0, .58, 1)',
  duration: 100,
  delay: 0,
  staggerDurationBy: 0,
  staggerDelayBy: 0,
  enterAnimation: 'elevator',
  leaveAnimation: 'elevator',
  maintainContainerHeight: false,
  typeName: 'div',
  disableAllAnimations: false,
  getPosition: el => callIfPossible(el.getBoundingClientRect())
};
export default UIDragList;